import React, { forwardRef } from 'react'

import { classes } from '../utils'

type Variant = 'default' | 'danger'
type Props = {
  open?: boolean
  variant?: Variant
  additionalBorder?: 'left' | 'right'
} & React.ButtonHTMLAttributes<HTMLButtonElement>
const ToolBarButton = forwardRef<HTMLButtonElement, Props>(
  (
    { open, className, variant = 'default', additionalBorder, ...props },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        className={classes(
          'flex h-10 min-w-[2.5rem] flex-shrink-0 items-center justify-center border-b border-b-transparent transition-colors duration-150 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-focus-outline',
          {
            'border-b-transparent bg-gray-200/60 dark:border-b-transparent dark:bg-gray-800/80':
              open && variant === 'default',
            'border-b-red-500 bg-red-100/60 dark:border-b-red-600 dark:bg-red-800/80':
              open && variant === 'danger',
          },
          {
            'text-gray-text hover:border-b-gray-300 hover:bg-gray-100/75 dark:text-gray-300 dark:hover:border-b-gray-700 dark:hover:bg-gray-800/80 dark:hover:text-gray-200':
              variant === 'default',
          },
          {
            'text-red-500 hover:border-b-red-500 hover:bg-red-100/75 dark:hover:border-b-red-400 dark:hover:bg-red-800/40 dark:hover:text-red-300':
              variant === 'danger',
          },
          {
            'border-l border-l-gray-300 dark:border-l-gray-600':
              additionalBorder === 'left' && variant === 'default',
          },
          {
            'border-r border-r-gray-300 dark:border-r-gray-600':
              additionalBorder === 'right' && variant === 'default',
          },
          {
            'border-l border-l-red-500 dark:border-l-red-600':
              additionalBorder === 'left' && variant === 'danger',
          },
          {
            'border-r border-r-red-500 dark:border-r-red-600':
              additionalBorder === 'right' && variant === 'danger',
          },
          {
            'cursor-not-allowed border-b-transparent bg-transparent text-gray-300 hover:border-b-transparent hover:bg-transparent dark:hover:border-b-transparent dark:hover:bg-transparent':
              props.disabled,
          },
          className,
        )}
        {...props}
      />
    )
  },
)
ToolBarButton.displayName = 'ToolBarButton'

export default ToolBarButton
